import React, { useEffect, useState } from 'react'
import { currencyFormat } from '../../../Product/common/components'

const LiveAuctionTrackerCard = (props) => {
    const trackData = props.data

    console.log(trackData, 'trackDatatrackDatatrackData')
    const cardData = [
        {
            location: trackData?.auctionlocation,
            bestDeal: true,
            timer: 'asdad',
            currentbid: trackData?.wprice,
        },
        {
            location: trackData?.auctionlocation,
            bestDeal: false,
            timer: 'asdad',
            currentbid: trackData?.wprice,
        },
        {
            location: trackData?.auctionlocation,
            bestDeal: false,
            timer: 'asdad',
            currentbid: trackData?.wprice,
        },
    ]

    const styles = [{ color: '#e12114' }, { color: '#e12114' }, { color: '#16a249' }]

    return (
        <>
            {cardData.map((data, index) => (
                <div className="liveAucCard" id={`index${index}`} key={index}>
                    <div className="lftCardItem">
                        <div className="location">
                            <strong className="loc">Location: {data.location}</strong>
                            {data.bestDeal && <span className="liveBadge">Best Deal</span>}
                        </div>
                        <div className="timerLst">
                            <span className="material-icons-outlined timeer">access_time</span>
                            <span className="tm">Ends in 2h 34m</span>
                        </div>
                    </div>
                    <div className="cardLst">
                        <div className="cardTags">
                            <p className="p">Current Bid</p>
                            <h3 className="val">
                                {currencyFormat(parseFloat(data.currentbid).toFixed(2))}{' '}
                            </h3>
                        </div>
                        <button className="liveView">
                            View{' '}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-external-link h-4 w-4"
                            >
                                <path d="M15 3h6v6"></path>
                                <path d="M10 14 21 3"></path>
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            ))}
        </>
    )
}

export default LiveAuctionTrackerCard
